import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { MapPinOff, ArrowLeft, Home } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import "../styles/button.css";
import "../styles/common.css";
import "./NotFound.css";

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const homePath = isAuthenticated ? "/uebersicht" : "/";
  const homeLabel = isAuthenticated ? "Zur Übersicht" : "Zum Login";

  return (
    <div className="page-container not-found-page">
      <Card className="not-found-page__card default-padding-card">
        <div className="not-found-page__content">
          <div className="not-found-page__badge" aria-hidden>
            404
          </div>
          <div className="not-found-page__icon-wrap" aria-hidden>
            <MapPinOff size={40} strokeWidth={1.75} />
          </div>
          <h1 className="not-found-page__title">Seite nicht gefunden</h1>
          <p className="not-found-page__summary">
            Die angeforderte Adresse existiert nicht oder wurde verschoben.
          </p>
          {location.pathname ? (
            <p className="not-found-page__path">
              <code>{location.pathname}</code>
            </p>
          ) : null}
          <div className="not-found-page__actions">
            <button
              type="button"
              className="btn btn-cancel btn-sm"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={16} aria-hidden />
              <span>Zurück</span>
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm not-found-page__home-btn"
              onClick={() => navigate(homePath, { replace: true })}
            >
              <Home size={16} aria-hidden />
              <span>{homeLabel}</span>
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default NotFound;
